module.exports = __webpack_public_path__ + "a9ec39b853d24775ce4e20a8fafbbeb4.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/2055_teaser_image.jpg
// module id = 579
// module chunks = 0